import React from 'react'
import { Box, Divider, Typography } from '@mui/material'
import { TooltipSeeker } from '@ui-seeker/core'

export default function ComparisonContent({ diff_price, comparison_type, mainName, clickable, compact = false }) {
	if (!mainName) return null

	const icons = {
		'more expensive': {
			color: 'error.main',
			// Same convention as the "Avg gap" column: the sign reads from the main
			// brand's side, so a plus is always good news for it.
			sign: '−',
			tooltip: `${mainName} is ${Math.abs(diff_price || 0)}% more expensive`,
		},
		'cheaper': { color: 'success.dark', sign: '+', tooltip: `${mainName} is ${Math.abs(diff_price || 0)}% cheaper` },
		'equal': { sign: '', tooltip: `${mainName} has the same price` },
		'noComparison': { tooltip: '', color: '', sign: '' },
	}

	const { color, tooltip, sign } = icons[comparison_type]


	const centerFlexStyle = {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		gap: 0.5,
	}

	// The main brand is named once above the table, so the compact cell spends its
	// width on the gap alone and leaves the name to the tooltip.
	if (compact) {
		return <TooltipSeeker title={tooltip}>
			<Box sx={{ ...centerFlexStyle, ...!clickable && { visibility: 'hidden' } }}>
				<Typography variant="caption" sx={{ fontWeight: 'bold', color }}>
					{sign}{Math.abs(diff_price || 0)}%
				</Typography>
			</Box>
		</TooltipSeeker>
	}

	return <Box
		sx={{
			...!clickable && { visibility: 'hidden' },
			textAlign: 'center',
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			justifyContent: 'center',
		}}>
			<Divider sx={{ my: 1, width: '90%', borderBottom: '1px solid' }}/>

			<TooltipSeeker title={tooltip}>
				<Box sx={{ ...centerFlexStyle, flexDirection: 'column' }}>
					<Box sx={centerFlexStyle}>
						<Typography variant="caption" sx={{ color: 'text.secondary' }}>
							Vs:
						</Typography>
						<Typography variant="caption" sx={{ fontWeight: 'bold' }}>
							{mainName}
						</Typography>
					</Box>
					<Box sx={centerFlexStyle}>
						<Typography
							variant="caption"
							sx={{ fontWeight: 'bold', color }}
						>
							{Math.abs(diff_price || 0)}%
						</Typography>
					</Box>
				</Box>
			</TooltipSeeker>
	</Box>
}
